import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Text } from 'rebass';
import styled from 'styled-components';
import theme from 'styled-theming';
import { ReactComponent as ProductSVG } from '../assets/product_logo.svg';

const iconColor = theme('mode', {
  light: (props) => props.theme.colors.mediumPurple,
  dark: (props) => props.theme.colors.greyLighter,
});

const textColor = theme('mode', {
  light: (props) => props.theme.colors.royalBlue,
  dark: (props) => props.theme.colors.white,
});

const ProductName = styled(Text)`
  line-height: 1.4;
  font-weight: ${(props) => props.fontWeight};
  color: ${textColor};
  cursor: ${(props) => (props.clickable ? 'pointer' : 'inherit')}
`;

const Logo = styled(ProductSVG)`
  color: ${iconColor};
`;

function ProductLogo(props) {
  const {
    logoWidth, logoHeight, ...otherProps
  } = props;
  return (
    <Flex alignItems="center" mb={3}>
      <Logo width={logoWidth} height={logoHeight} />
      <ProductName flex={1} {...otherProps}>
        Conversation Orchestrator
      </ProductName>
    </Flex>
  );
}

ProductLogo.propTypes = {
  logoWidth: PropTypes.string.isRequired,
  logoHeight: PropTypes.string.isRequired,
};

export default ProductLogo;
